import { useState } from "react";
import { toast } from "sonner";
import { Plus, Trash2 } from "lucide-react";
import api, { formatApiErrorDetail } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import AdminCard from "../AdminCard";

const COLORS = ["#0D4F3C", "#D4A537", "#2563EB", "#DC2626", "#7C3AED", "#0891B2"];

export const GroupsPanel = ({ groups, selected, onSelect, reload }) => {
    const [name, setName] = useState("");
    const [color, setColor] = useState(COLORS[0]);

    const add = async (e) => {
        e.preventDefault();
        try { await api.post("/mailing/groups", { name, color }); setName(""); toast.success("Grupa utworzona."); reload(); }
        catch (err) { toast.error(formatApiErrorDetail(err.response?.data?.detail)); }
    };
    const del = async (g) => {
        if (!window.confirm(`Usunąć grupę „${g.name}”? Adresy pozostaną na liście.`)) return;
        await api.delete(`/mailing/groups/${g.id}`); toast.success("Usunięto grupę."); if (selected === g.id) onSelect(""); reload();
    };

    return (
        <AdminCard>
            <h3 className="font-serif text-xl text-[#092E22] mb-4">Grupy odbiorców</h3>
            <form onSubmit={add} className="flex gap-2 mb-3" data-testid="mailing-group-form">
                <Input required value={name} onChange={(e) => setName(e.target.value)} placeholder="np. Klatka 25C, Zarząd" data-testid="mailing-group-name" />
                <Button type="submit" className="rounded-full bg-[#0D4F3C] hover:bg-[#092E22] text-white shrink-0" data-testid="mailing-group-add"><Plus size={14} /></Button>
            </form>
            <div className="flex gap-1.5 mb-5">
                {COLORS.map((c) => (
                    <button key={c} type="button" onClick={() => setColor(c)} className={`w-6 h-6 rounded-full border-2 ${color === c ? "border-[#092E22] scale-110" : "border-white"} transition-transform`} style={{ background: c }} aria-label={c} />
                ))}
            </div>
            <div className="space-y-1.5" data-testid="mailing-group-list">
                {[{ id: "", name: "Wszyscy adresaci", color: "#9ca3af", system: true }, ...groups.filter((g) => !g.system)].map((g) => (
                    <div key={g.id || "all"} onClick={() => onSelect(g.id)} data-testid={`mailing-group-row-${g.id || "all"}`}
                        className={`flex items-center justify-between gap-2 px-3 py-2.5 rounded-xl cursor-pointer transition-colors ${selected === g.id ? "bg-[#0D4F3C]/10" : "hover:bg-[#FAF8F3]"}`}>
                        <span className="flex items-center gap-2 text-sm text-[#092E22] min-w-0">
                            <span className="w-2.5 h-2.5 rounded-full shrink-0" style={{ background: g.color }} />
                            <span className="truncate">{g.name}</span>
                            {g.count !== undefined && <span className="text-[10px] font-mono text-gray-400">{g.count}</span>}
                        </span>
                        {!g.system && (
                            <button onClick={(e) => { e.stopPropagation(); del(g); }} className="text-red-400 hover:text-red-600 p-1" data-testid={`mailing-group-delete-${g.id}`}><Trash2 size={13} /></button>
                        )}
                    </div>
                ))}
            </div>
            <p className="text-[11px] text-gray-400 mt-4">Grupa „Subskrybenci newslettera” jest automatyczna – zobaczysz ją w zakładce „Subskrybenci”.</p>
        </AdminCard>
    );
};

export default GroupsPanel;
